const TEMPLATE_MODEL = {
  1: {
    name: "Video",
    props: {
      readable: "",
      src: "3xYhxEHim-AXE_bg_transcoded-NzLLP40Tx2jrqLtL-EGADD_CS_01_ITAR_A.mp4",
      poster: "*",
      cuepoints: [],
      //colors: [
      //   {
      //     id: 1,
      //     color: "#ff9900",
      //   },
      //   {
      //     id: 2,
      //     color: "#F3C465",
      //   },
      //   {
      //     id: 3,
      //     color: "#3381a4",
      //   },
      //   {
      //     id: 4,
      //     color: "#ffffff",
      //   },
      // ],
    },
  },
  2: {
    name: "Audio",
    props: {
      readable: "<p>Click to play.</p>",
      src: "Dd2dea1cEC4yuKPZ_transcoded-5SdPkKZYb6-yWp5N-CS06_Text_Audio_01.mp3",
      isVisited: true,
    },
  },
  3: {
    name: "Accordion",
    props: {
      panelList: [
        {
          id: 1,
          title: "Lorem ipsum 1",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
          imgUrl: "",
          imgPosition: "center",
        },
        {
          id: 2,
          title: "Lorem ipsum 2 ",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ",
          imgUrl: "",
          imgPosition: "center",
        },
        {
          id: 3,
          title: "Lorem ipsum 3",
          description:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. ",
          imgUrl: "",
          imgPosition: "center",
        },
      ],
    },
  },
  4: {
    name: "Tabs",
    props: {
      items: [
        {
          id: 1,
          title: "Lorem ipsum 1",
          description:
            "You should check whether the reexport is authorised on the BIS licence obtained by SuppEAR. If not, you could obtain your own BIS licence for the reexport or review for an EAR licence exception.",
          imageUrl: "BwZcC1qNZQEdgPRI_GGN-UY1so2CIKs-t.png",
        },
        {
          id: 2,
          title: "Lorem ipsum ",
          description:
            "Next, you review the available licence exceptions to determine which may apply to your transaction. One of the applicable EAR licence exceptions is GOV for governments of certain countries.You must review the requirements for claiming License Exception GOV for the EAR-controlled items incorporated in your life support system.",
          imageUrl: "MP0jr9s6Afs22Cos_feb_-tqmR4h_AhFb.jpg",
        },
      ],
    },
  },
  5: {
    name: "Carousels",
    props: {
      carousalData: [
        {
          description: "<p></p>",
          image:
            "https://s3.us-east-1.amazonaws.com/library.contentenablers.com/ceauthor/images/uk_sanctions_and_embargoes.jpeg",
        },
        {
          description: "<p></p>",
          image:
            "https://s3.us-east-1.amazonaws.com/library.contentenablers.com/ceauthor/images/Aerospace_Industry.png",
        },
        {
          description: "<p></p>",
          image:
            "https://s3.us-east-1.amazonaws.com/library.contentenablers.com/ceauthor/images/uk_sanctions_and_embargoes.jpeg",
        },
      ],
      width: 900,
      autoPlay: false,
      selectedItem: 0,
      isTextSeprate: false,
      dynamicHeight: false,
      // These keys are from previously added static data and are available for use if needed. 
      // The previous lrn is also available inside the props.
      // axis: "horizontal",
      // infiniteLoop: true,
      // interval: 3000,
      // showArrows: true,
      // showStatus: false,
      // showIndicators: true,
      // showThumbs: false,
      // stopOnHover: true,
      // swipeable: true,
      // verticalSwipe: "natural",
      // useKeyboardArrows: true,
      // thumbWidth: 80,
      // swipeScrollTolerance: 5,
    },
  },
  6: {
    name: "CourseImageFlip",
    props: {
      items: [
        {
          id: 1,
          frontImage: "R9FxiGNlD9UKdiSI_iRv9EJQPns_fRWCl.png",
          backImage:
            "https://img.buzzfeed.com/buzzfeed-static/static/2014-04/enhanced/webdr06/4/16/enhanced-11136-1396643149-13.jpg?no-auto",
          flipBtnText: "click to flip",
          description:"insert text",
          flipped: false,
        },
        {
          id: 2,
          frontImage: "0_w5bmENuvTefJfq_vAbcnuCkPZl3CEIC.png",
          backImage:
            "https://img.buzzfeed.com/buzzfeed-static/static/2014-04/enhanced/webdr06/4/16/enhanced-11136-1396643149-13.jpg?no-auto",
          flipBtnText: "click to flip",
          description:"insert text",
          flipped: false,
        },
        {
          id: 3,
          frontImage: "YrtXVKi3wBH2vIbl_DPdNcPeIo1Gor6NL.png",
          backImage:
            "https://img.buzzfeed.com/buzzfeed-static/static/2014-04/enhanced/webdr06/4/16/enhanced-11136-1396643149-13.jpg?no-auto",
          flipBtnText: "click to flip",
          description:"insert text",
          flipped: false,
        },
      ],
    },
  },
  7: {
    name: "CourseCardFlip",
    props: {
      items: [
        {
          id: 1,
          frontImage: "R9FxiGNlD9UKdiSI_iRv9EJQPns_fRWCl.png",
          backImage:
            "https://img.buzzfeed.com/buzzfeed-static/static/2014-04/enhanced/webdr06/4/16/enhanced-11136-1396643149-13.jpg?no-auto",
          flipBtnText: "click to flip",
          description:"insert test",
          flipped: false,
          title: "insert card title",
        },
        {
          id: 2,
          frontImage: "0_w5bmENuvTefJfq_vAbcnuCkPZl3CEIC.png",
          backImage:
            "https://img.buzzfeed.com/buzzfeed-static/static/2014-04/enhanced/webdr06/4/16/enhanced-11136-1396643149-13.jpg?no-auto",
          flipBtnText: "click to flip",
          description:"insert test",
          flipped: false,
          title:"insert card title",
        },
        {
          id: 3,
          frontImage: "GfnD9YA2G7aUv0Mz_JqrPbYhngdTNiDdg.png",
          backImage:
            "https://img.buzzfeed.com/buzzfeed-static/static/2014-04/enhanced/webdr06/4/16/enhanced-11136-1396643149-13.jpg?no-auto",
          flipBtnText: "click to flip",
          description:"insert test",
          flipped: false,
          title: "insert card title",
        },
      ],
    },
  },
  8: {
    name: "DragnDrop",
    props: {
      items: ["1", "2", "3"],
      draggableItems: {
        1: [
          {
            id: 1,
            image: "Schematics.png",
          },
          {
            id: 2,
            image: "Marketing_Data.png",
          },
          {
            id: 3,
            image: "Photographs.png",
          },
        ],
        2: [
          {
            id: 3,
            image: "Marketing_Data.png",
          },
          {
            id: 1,
            image: "Photographs.png",
          },
          {
            id: 2,
            image: "Photographs.png",
          },
        ],
        3: [
          {
            id: 3,
            image: "Schematics.png",
          },
          {
            id: 1,
            image: "Marketing_Data.png",
          },
          {
            id: 2,
            image: "Schematics.png",
          },
        ],
      },
    },
  },
  9: {
    name: "HalfImageText",
    props: {
      items: [
        {
          id: 1,
          imageUrl:
            "https://s3.us-east-1.amazonaws.com/library.contentenablers.com/ceauthor/images/car_image.png",
          isHalf: true,
          title: "Heading Text should go Here",
          description:"insert text",
          textPosition: "center",
        },
      ],
    },
  },
  10: {
    name: "ImageText",
    props: {
      title:
        '<div><div class="block-text block-text--heading" style="padding-top: 30px; padding-bottom: 20px;"><div class="block-text__container" data-ba="blocks.blockText"><div class="block-text__row"><div class="block-text__col brand--head"><h2><div aria-hidden="false" class="brand--linkColor"><div class="fr-view"><p><strong>So, how do you resolve all these issues?&nbsp;</strong></p><p><strong>Let’s start at the beginning.<br></strong></p></div></div></h2></div></div><div class="block-text__row"></div></div></div></div>',
      items: [
        {
          id: 1,
          imageUrl: "CHQ9NQTTfmfJbRil_5QfP5gL8iBnu-SME.jpg",
          isHalf: true,
          description:
            "First, if you are operating under a BIS export licence, you’ll need to confirm that it includes your third-country supplier as a party to receive EAR-controlled technology.",
          textPosition: "flex-start",
        },
      ],
    },
  },
  11: {
    name: "ImageMap",
    props: {
      image: "_kgrrjmM5Z4Dy9SC_aoN3tosYWnozjZ45.png",
      mappings: [
        {
          id: 1,
          map: {
            name: "one",
            x: 80,
            y: 34,
          },
          isOpen: false,
          content:
            "<div><p className='mapping-content'>Alex</p><p>No action is required as to your product engineer, Alex, a dual national of the UK and Russia, because the EAR looks only to the most recent nationality of the employee, which, for Alex, is the UK.</p></div>",
        },
        {
          id: 2,
          map: {
            name: "two",
            x: 80,
            y: 61,
          },
          isOpen: false,
          content:
            "<div><p className='mapping-content'>Anna</p><p>Turning to Anna, a third-country national, if you received the technology under a BIS licence, §750.7 permits the release of the technology to your permanent regular employees located at the facility on the licence. If you received the technology under License Exception STA, you will need to confirm that Tactix has complied with §734.20 of the EAR, which covers transfers of technology to third-country nationals, so that you can be sure that your quality control manager, Anna, a Polish national, can safely access the controlled technology. Because Anna is a national of Poland, a country in Country Group A:5, §734.20 authorises the release of the technology to her.</p></div>",
        },
        {
          id: 3,
          map: {
            name: "three",
            x: 80,
            y: 88,
          },
          isOpen: false,
          content:
            "<div><p className='mapping-content'>Ben</p><p>Finally, you will need to confirm that your third-country supplier has also complied with §734.20 of the EAR before granting Ben, the French-Chinese dual national, access to the EAR-controlled technology. Again, under the EAR, Ben is considered a French national, not a dual national, and is authorised, as France is in Country Group A:5.</p></div>",
        },
      ],
    },
  },
  12: {
    name: "OrderedList",
    props: {
      snippetOne:
        "Lorem ipsum dicta minus molestiae vel beatae natus eveniet ratione temporibus aperiam harum alias officiis assumenda officia quibusdam deleniti eos cupiditate dolore doloribus",
      snippetTwo:
        "Lorem ipsum dicta minus molestiae vel beatae natus eveniet ratione temporibus aperiam harum alias officiis assumenda officia quibusdam deleniti eos cupiditate dolore doloribus",
      list: [
        "Lorem ipsum is a dummy text for printing and typesetting industry",
        "Lorem ipsum is a dummy text ",
        "Lorem ipsum is a dummy text for printing",
        "Lorem ipsum",
        "Lorem ipsum is a dummy text for printing and typesetting industry",
        "Lorem ipsum is a dummy text",
        "Lorem ipsum",
      ],
    },
  },
  13: {
    name: "UnorderedList",
    props: {
      snippetOne:
        "Lorem ipsum dicta minus molestiae vel beatae natus eveniet ratione temporibus aperiam harum alias officiis assumenda officia quibusdam deleniti eos cupiditate dolore doloribus",
      snippetTwo:
        "Lorem ipsum dicta minus molestiae vel beatae natus eveniet ratione temporibus aperiam harum alias officiis assumenda officia quibusdam deleniti eos cupiditate dolore doloribus",
      list: [
        "Lorem ipsum is a dummy text for printing and typesetting industry",
        "Lorem ipsum is a dummy text ",
        "Lorem ipsum is a dummy text for printing",
        "Lorem ipsum",
        "Lorem ipsum is a dummy text for printing and typesetting industry",
        "Lorem ipsum is a dummy text",
        "Lorem ipsum",
      ],
    },
  },
  14: {
    name: "RadioSelect",
    props: {
      answer: 1,
      explanation: {
        wrong: "INCORRECT ANSWER FEEDBACK.",
        right: "CORRECT ANSWER FEEDBACK.",
      },
      title: "Knowledge Check",
      question:"insert question text",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
      options: [
        { id: 1, title: "True 1", value: 1 },
        { id: 2, title: "False 2", value: 2 },
      ],
    },
  },
  15: {
    name: "ImageSelect",
    props: {
      answer: 2, // items id reference for answer
      explanation: {
        wrong: "INCORRECT ANSWER FEEDBACK.",
        right: "CORRECT ANSWER FEEDBACK.",
      },
      text: 'insert question text.',
      items: [
        {
          id: 1,
          name: "IMAGE TITLE",
          img_url:
            "https://s3.us-east-1.amazonaws.com/library.contentenablers.com/ceauthor/images/Aerospace_Industry.png",
        },
        {
          id: 2,
          name: "IMAGE TITLE",
          img_url:
            "https://s3.us-east-1.amazonaws.com/library.contentenablers.com/ceauthor/images/home_video_poster_min_jpg_a7bfb35464.jpeg",
        },
        {
          id: 3,
          name: "IMAGE TITLE",
          img_url:
            "https://s3.us-east-1.amazonaws.com/library.contentenablers.com/ceauthor/images/medical_page_hero.jpeg",
        },
        {
          id: 4,
          name: "IMAGE TITLE",
          img_url:
            "https://s3.us-east-1.amazonaws.com/library.contentenablers.com/ceauthor/images/Fuk_sanctions_and_embargoes.jpeg",
        },
      ],
    },
  },
  16: {
    name: "TopicHeader",
    props: {
      title: "Welcome and Introduction",
      description:
        "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
      styleObj: {
        boxShadow: "none",
        margin: 0,
        borderRadius: 0,
        background: "#13984b",
        color: "#ffffff",
        fontStyle: "normal",
      },
    },
  },
  17: {
    name: "TopicDescription",
    props: {
      Header: "Foundation",
      description:
        "insert text",
    },
  },
  20: {
    name: "ArchiveVideo",
    props: {
      description: "",
      src: "https://d14rwvged4djyq.cloudfront.net/type3/10000/IN_PRODUCTION.mp4",
      poster: "*",
      ccid: 9031,
      cuepoints: [],
      content:
        "<section><p>Dual-use items include commercial goods, systems, equipment, components, software, and technology that are normally used for a commercial purpose, but can also be used to design, manufacture, or operate military items- hence the term dual-use because they have a commercial and non-commercial use. For example, valves with a special coating on them are useful for handling liquids that contain corrosive commercial chemicals for civilian applications. But these same valves are also useful for handling highly corrosive chemicals used in making chemical weapons. Sophisticated computers or encryption hardware may not only be used by commercial internet providers but also by the military.</p><p>Most industrialised countries including the member states of the European Union, the United States, and many nations in Asia, identify Dual-use items on common lists which are generally broken down by categories identifying each individual item by a specific assigned number sometimes referred to as an Export Control Classification Number or ECCN. An item needs to be considered as covered by a list if its technical parameters meet the parameters of the respective list number.</p><p>As mentioned earlier, export controls do not only deal with hardware, but also with software and technology. Therefore, the regulations also control any technical data or software associated with the product. It doesn&#39;t matter what form the technical data comes in - whether it is a blueprint, drawing, photograph, email, or written on a paper napkin - it is the information itself that is controlled. The regulations focus on the control of military technology transferred by electronic means, which can include by telephone if the technology is contained in a document and read out over the phone. There are some situations where technical data is not controlled because it is generally available to the public in textbooks and the like. But again, the regulations are not detailed about what is technical data for individual products and the interpretation of what is publicly available is complicated. Your international trade compliance experts are there to provide you with the answers.</p></section><section><p>Most governments generally require licences for the export of dual-use items to specific destinations. Whether a licence may be granted or rejected is determined by several factors - for example, a country&#39;s security interests, its foreign policy goals, or economic objectives. There are often both general and specific exceptions to the requirement to obtain a licence. These exceptions are usually limited to specific purposes under very specific conditions. Many companies have gotten into trouble because employees who are not international trade compliance experts have read the regulations, found what they thought was an exception, and then later found out that it did not apply - therefore, creating a violation. Before engaging in any export activities involving controlled items, you should consult with your international trade compliance experts to determine whether you need to get a licence or some other authorisation to either export it to another country or to share information about the item with a person from another country.</p><p>In addition to pure item-related controls, many countries maintain so-called catch-all controls. These end-use-based controls require that you obtain an export licence for any export of any item (whether on the respective dual-use list or not) for weapons of mass destruction or missile technology related projects and even military projects in certain embargoed countries.</p></section>",
      subtitleurl:
        "https://d14rwvged4djyq.cloudfront.net/type3/4/subtitle/CE_04_04.txt",
    },
  },
  21: {
    name: "BackgroundImage",
    props: {
      bgImageUrl: "*",
      header: "Foundation",
      description:"insert text",
      // "styleObj": { "color": "#fff" },
      backgroundSize: "cover",
      textPosition: "center",
      backgroundColor: "rgba(7, 13, 89, 0.6)",
      opacity: "0.6",
      padding: "3px",
    },
  },
  22: {
    name: "Search",
    props: {},
  },
  23: {
    name: "Attachments",
    props: {
      // Default word
      items: [
        {
          id: 1,
          notes:"insert text",
          path: "test.docx",
        },
      ],
    },
  },
  24: {
    name: "CardStackCarousel",
    props: {
      items: [
        { cover: "*", title: "Interstaller" },
        { cover: "*", title: "Venom" },
        { cover: "*", title: "ironman" },
        { cover: "*", title: "some" },
        { cover: "*", title: "Inception" },
      ],
      postivebtnlabel: "Select",
      negativebtnlabel: "Reject",
      infinite: true,
    },
  },
  25: {
    name: "ImageMapper",
    props: {
      img: "https://s3.us-east-1.amazonaws.com/library.contentenablers.com/ceauthor/images/uk_sanctions_and_embargoes.jpeg",
      shape: "rect",
      background_color: "#13984B",
      text_color: "#f1ebeb",
      highlight_backround: "#13984B",
      crop_area: null,
      edit_idx: null,
      areas: [
        {
          left: "0%",
          top: "6%",
          height: "12%",
          width: "33%",
          style: { background: "#13984B" },
          message:
            "<p><strong>Click and drag</strong> on the image to establish hotspots. <strong>Hover over</strong> a hotspot to access additional editing tools</p>",
          title: "Click for instructions",
          isOpen: false,
          shape: "rect",
        },
      ],
    },
  },
  26: {
    name: "KnowledgeCheck",
    props: {
      items: [
        {
          id: 1,
          questionText: `Which of the following are controlled for export by most governments?`,
          answer: [
            { answerText: "Military items", isCorrectAnswer: false },
            { answerText: "Dual-use items", isCorrectAnswer: false },
            {
              answerText:
                "Items traded with sanctioned persons, entities, or destinations",
              isCorrectAnswer: false,
            },
            { answerText: "All of the above", isCorrectAnswer: true },
          ],
          questionType: "single",
        },
      ],
    },
  },
  27: {
    name: "Quizzes",
    props: {
      items: [],
    },
  },
  28: {
    name: "Draggables",
    props: {
      question: "Drag each item to the correct field below",
      head: "Drag each ECCN element to the appropriate box",
      subhead: "Match the action with the correct method.",
      enable_voice: false,
      enable_strict:true,
      feedback:false,
      explanation: {
        right: "Congratulations! You completed this interactivity.",
        wrong: `The items highlighted in red are not correct. Please click "Restart" and try again.`,
      },
      bucket: [
        {
          id: "0",
          container: [],
          // "image": "",
          text: "DBox 001",
        },
        {
          id: "1",
          container: [],
          // "image": "",
          text: "DBox 002",
        },
      ],
      drags: [
        {
          id: "0",
          target: "0",
          audio:
            "Dd2dea1cEC4yuKPZ_transcoded-5SdPkKZYb6-yWp5N-CS06_Text_Audio_01.mp3",
          image: "",
          text: "0001",
          feedback:['Correct.','Sorry, that’s not correct.']
        },
        {
          id: "1",
          target: "0",
          audio: "",
          image: "bg_1_.JPG",
          text: "0002",
          feedback:['Correct.','Sorry, that’s not correct.']
        },
      ],
    },
  },
  30: {
    name: "Quotes",
    props: {
      profileImage: "profile_icon.png",
      quotes:
        "❝ Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting. ❞",
      backgroundObj: {
        img: "none",
        size: "cover",
        color: "#000000",
        opacity: "0.6",
        background: "right top / cover no-repeat",
      },
      styleObj: {
        padding: 8,
        textPosition: "center",
        imageSize: 40,
        imagePosition: "left",
      },
    },
  },
  31: {
    name: "ScenarioBlock",
    props: {
      scene: [
        {
          id: "1",
          bg_image:
            "https://s3.amazonaws.com/thumbs.contentenablers.com/assetslib/images/6342810c2e20c474c0056e07.png",
          slides: [
            {
              id: "1.1",
              goTo: 0,
              type: 0,
              title: "Slide",
              emotion: null,
              next_slide: null,
              responses: [],
              description: `<p>Add text to explain the situation your scenario will address.</p>`,
            },
            {
              id: "1.2",
              goTo: 1,
              type: 1,
              title: "Slide",
              emotion: null,
              next_slide: {
                scene: "1",
                slide: "1.3",
              },
              responses: [
                {
                  id: "1.2.1",
                  goTo: 2,
                  action: "Try Again",
                  title: "Response",
                  emotion:null,
                  feedback: "<p>Add the feedback here to let learners know they got it right.</p>",
                  next_slide: null,
                  description: "Scenario Travel End.",
                },
                {
                  id: "1.2.2",
                  goTo: 0,
                  action: "continue",
                  title: "Response",
                  emotion: "happy",
                  feedback: "<p>Sorry, try again.</p>",
                  next_slide: null,
                  description: "Scenario Travel next slides.",
                },
                {
                  id: "1.2.3",
                  goTo: 2,
                  action: "continue",
                  title: "Response",
                  emotion: "happy",
                  feedback: "<p>Sorry, try again.</p>",
                  next_slide: {
                    scene: "1",
                    slide: "1.3",
                  },
                  description: "Scenario Ended.",
                },
              ],
              description: `<p>Add text to explain the situation your scenario will address.</p>`,
            },
            {
              id: "1.3",
              goTo: 2,
              type: 0,
              title: "Slide",
              emotion: "happy",
              next_slide: null,
              responses: [],
              description: `<p>Thanks to participate.</p>`,
            },
          ],
          character: {
            src: "*",
            isCharacter: false,
          },
        },{
          id: -1,
          title: "Scenario Completed !",
          next_slide: {
              scene: "1",
              slide: "1.1"
          },
          goTo: 1,
          slides: [],
          type: 0,
          responses: []
      }
      ],
    },
  },
  32: {
    name: "DragandMatch",
    props: {
      description:
        "<p>Drag each items in the right column to the space in the middle column next to its match</p>",
      explanation: {
        right:
          '<p><span style="color: #4CAF50;"><strong>Congratulations! You completed this interactivity.</strong></span></p>\n',
        wrong: `Oh no! You lost! The statements that are shown in red are not in the appropriate category!...Please try again by clicking "Restart".`,
      },
      styleObj: {
        dr_bg_color: "#f8f9fa",
      },
      bucket: [
        {
          id: "0",
          container: [],
          text: "<p>Enter your question here&nbsp;&nbsp;</p>",
        },
        {
          id: "1",
          container: [],
          text: "<p>Enter your question here 01 &nbsp;&nbsp;</p>",
        },
      ],
      drags: [
        {
          id: "0",
          target: "0",
          image: "",
          text: "<p>Enter your answer here&nbsp;&nbsp;</p>",
        },
        {
          id: "1",
          target: "1",
          image: "",
          text: "<p>Enter your answer here 01 &nbsp;&nbsp;</p>",
        },
      ],
    },
  },
  33: {
    name: "ReorderingList",
    props: {
      description:
        "<p>Drag the following statements into the correct order</p>",
      explanation: {
        right:
          '<p><span style="color: #4CAF50;"><strong>Congratulations! You have completed this interactivity.</strong></span></p>\n',
        wrong: `Oh no! You lost! The statements that are shown in red are not in the appropriate category!...Please try again by clicking "Restart".`,
      },
      styleObj: {
        dr_bg_color: "#f8f9fa",
      },
      answer: [1, 2, 3],
      list: [
        {
          id: 1,
          text: "<p>In this activity, your task is to rearrange the given elements into the correct sequence.</p>",
        },
        {
          id: 2,
          text: "<p>You'll be sorting and organizing the provided information to create a coherent order.</p>",
        },
        {
          id: 3,
          text: "<p>Once completed, you'll receive a confirmation message for successfully reordering the elements.</p>",
        },
      ],
    },
  },
  34: {
    name: "ImageGallery",
    props: {
      rowimg: 3,
      height: 200,
      items: [
        {
          id: 1,
          img: "*",
          desc: `<p>caption 1</p>`,
          styles: {
            position: "center  / contain no-repeat",
            color: "rgba(0, 0, 0, 0)",
          },
        },
        {
          id: 2,
          img: "*",
          desc: `<p>caption 2</p>`,
          styles: {
            position: "center  / contain no-repeat",
            color: "rgba(0, 0, 0, 0)",
          },
        },
        {
          id: 3,
          img: "*",
          desc: `<p>caption 3</p>`,
          styles: {
            position: "center  / contain no-repeat",
            color: "rgba(0, 0, 0, 0)",
          },
        },
      ],
    },
  },
  35: {
    name: "DocumentViewer",
    props: {
      filePath: "",
      fileName: "test_document.docx",
      thumbnail: "",
      docPublicUrl:"",
      enablePublicUrl: false,
      layout: 1, // 1.parallel, 2.stacked, 3.embed,
      textPosition: 1, // if stacked or embed 2 means top and 1 means bottom, if parallel 2 means left and 1 means right  
      header: "Title PPT or Doc",
      description: "Description of PPT or Docs",
      footer: "Content Enablers",
    },
  },
  36: {
    name: "VideoHotspot",
    props: {
      readable: "",
      src: "66f9717fd5d45b618a1b2d55.mp4",
      poster: "*",
      intro:`<p><span style="font-size: 24px;">This video presents several scenarios where security breaches occur, and the system has been compromised. Watch the video carefully and identify these scenarios by clicking on the relevant points. If you select the correct scenario, it will be added to the reference bar at the bottom. Once all scenarios have been identified, the "End" button will be enabled, allowing you to view a summary of the learning exercise.</span></p>`,
      summary:`<p><span style="font-size: 24px;"> Congratulations! You have successfully completed!</span></p>`,
      forward_rewind:false,
      description:`<p><span style="font-size: 24px;">Please watch the video and click on the points where you identify a security breach.</span></p>`,
      warning:`<p><span style="font-size: 24px;">You have missed some instances of security breaches in this video. Please watch it again and identify all relevant contexts</span></p>`,
      e_title:`You have found {total_viewed} out of {total_point} security vulnerabilities`,
      duration:53.15,
      rewatch_ins:`<p>The progress you made by viewing the video will be reset if you rewatch it. Click <strong>OK</strong> to start the exercise again or <strong>Close</strong> to retain your progress.&nbsp;</p>`,
      items:[
        {
          id:1,
          type:0,
          point:[0,4.9],
          title:'A popup occurs at a specific point',
          desc:`<p><span style="font-size: 24px;">More detailed content is provided after clicking that active point</span></p>`,
          audio:'*'
        }
      ]
    },
  },
  // 37: {
  //   name: "CatchGame",
  //   props: {
  //    items:[
  //     {
  //       question: "Which is a better method for shipping large, heavy items over long distances?",
  //       op:["Sea Freight","Air Freight"],
  //       type:0,
  //       ans:[0]
  //     }
  //    ],
  //    bg_image:'../../../assets/img/seaView.jpg',
  //    target_img:'',
  //    gameSpeed:2,
  //    hasRandom:false,
  //    gameArea:1000,
  //   },
  // }
};

export default TEMPLATE_MODEL;

// "18": {
//     "name": "BarChart",
//     "props": {
//         "labels": [
//             "Valuvation",
//             "Screening",
//             "Export Controls",
//             "Incoterms",
//             "Pref and not-pref origin",
//             "Customs Management"
//         ],
//         "datasets": [
//             {
//                 "label": "# of Votes",
//                 "data": [
//                     12,
//                     19,
//                     7,
//                     8,
//                     5,
//                     11
//                 ],
//                 "backgroundColor": [
//                     "rgba(255, 99, 132, 0.2)",
//                     "rgba(54, 162, 235, 0.2)",
//                     "rgba(255, 206, 86, 0.2)",
//                     "rgba(75, 192, 192, 0.2)",
//                     "rgba(153, 102, 255, 0.2)",
//                     "rgba(255, 159, 64, 0.2)"
//                 ],
//                 "borderColor": [
//                     "rgba(255, 99, 132, 1)",
//                     "rgba(54, 162, 235, 1)",
//                     "rgba(255, 206, 86, 1)",
//                     "rgba(75, 192, 192, 1)",
//                     "rgba(153, 102, 255, 1)",
//                     "rgba(255, 159, 64, 1)"
//                 ],
//                 "borderWidth": 1
//             }
//         ]
//     }
// },
